import { action } from 'typesafe-actions';

import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { IErknmAnalyticsIndex } from 'APIPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsIndex';
import { IErknmAnalyticsFilter } from 'AnalyticsPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsFilter';
import { IErknmAnalyticsTableColumn } from 'AnalyticsPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsTableColumn';

import { ErknmAnalyticsProsecutorOrganizationActionsEnum } from '../enums/ErknmAnalyticsProsecutorOrganizationActionsEnum';

export const erknmAnalyticsProsecutorOrganizationInitPage = () =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.INIT_PAGE);
export const erknmAnalyticsProsecutorOrganizationGetData = () =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.GET_DATA);
export const erknmAnalyticsProsecutorOrganizationGetDataNext = () =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.GET_DATA_NEXT);
export const erknmAnalyticsProsecutorOrganizationSetData = (
  data: IErknmAnalyticsIndex[],
  page: number,
  hasMoreData: boolean,
  localDateTime: string,
) => action(ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_DATA, { data, page, hasMoreData, localDateTime });
export const erknmAnalyticsProsecutorOrganizationSetFilter = (filter: IErknmAnalyticsFilter) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_FILTER, { filter });
export const erknmAnalyticsProsecutorOrganizationSetTableColumns = (columns: IErknmAnalyticsTableColumn[]) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_TABLE_COLUMNS, { columns });
export const erknmAnalyticsProsecutorOrganizationGetAdditionalColumns = (columnId: IErknmAnalyticsTableColumn['id']) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.GET_ADDITIONAL_COLUMNS, { columnId });
export const erknmAnalyticsProsecutorOrganizationExport = (format: ExportFormatsEnum) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.EXPORT, { format });
export const erknmAnalyticsProsecutorOrganizationExportKnmList = (
  r: string,
  c: string,
  f: string | null,
  filter: IErknmAnalyticsFilter,
  format: ExportFormatsEnum,
) => action(ErknmAnalyticsProsecutorOrganizationActionsEnum.EXPORT_KNM_LIST, { r, c, f, filter, format });
export const erknmAnalyticsProsecutorOrganizationGetKnmList = (f: string | null, filter: IErknmAnalyticsFilter) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.GET_KNM_LIST, {
    f,
    filter,
  });
export const erknmAnalyticsProsecutorOrganizationGetKnmListNextPage = (
  f: string | null,
  filter: IErknmAnalyticsFilter,
) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.GET_KNM_LIST_NEXT_PAGE, {
    f,
    filter,
  });
export const erknmAnalyticsProsecutorOrganizationSetKnmList = (
  data: IKnmRaw[],
  page: number,
  pageCount: number,
  totalCount: number,
) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_KNM_LIST, {
    data,
    page,
    pageCount,
    totalCount,
  });
export const erknmAnalyticsProsecutorOrganizationSetOrder = (order: string | null) =>
  action(ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_ORDER, {
    order,
  });
